export var prepareAndToggleFieldErrors = function (meta, showErrorsOnInitialRender) {
    var uniqueErrors = new Set();
    if (meta.error) {
        addUniqueErrors(uniqueErrors, meta.error);
    }
    if (meta.submitError) {
        addUniqueErrors(uniqueErrors, meta.submitError);
    }
    var nonEmptyErrors = Array.from(uniqueErrors).filter(function (error) { return error.trim() !== ''; });
    var showErrors = (meta.error && (meta.dirty || meta.touched)) ||
        (meta.error && showErrorsOnInitialRender) ||
        (meta.submitError &&
            (meta.submitFailed ||
                meta.dirtySinceLastSubmit ||
                meta.touched ||
                showErrorsOnInitialRender));
    var errors = nonEmptyErrors.length > 0 ? nonEmptyErrors.join('\n') : null;
    return { showErrors: showErrors, errors: errors };
};
var addUniqueErrors = function (uniqueErrors, error) {
    if (!error)
        return;
    var errorMessage;
    var regexMatch;
    var regexPattern = /\/(.*)\//;
    var removeRegexSlashes = function (str) { return str.replace(/\/(.*)\//, '$1'); };
    switch (true) {
        case typeof error === 'string':
            regexMatch = regexPattern.test(error);
            errorMessage = regexMatch
                ? removeRegexSlashes(error)
                : error;
            if (errorMessage.trim() !== '') {
                uniqueErrors.add(errorMessage);
            }
            break;
        case error instanceof Array &&
            error.every(function (value) { return typeof value === 'string'; }):
            error.forEach(function (value) {
                regexMatch = regexPattern.test(value);
                errorMessage = regexMatch
                    ? removeRegexSlashes(value)
                    : value;
                if (errorMessage.trim() !== '') {
                    uniqueErrors.add(errorMessage);
                }
            });
            break;
        default:
            break;
    }
};
